<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 5.50037H14" stroke="currentColor" stroke-width="1.5"/>
<path d="M2 10.4996H14" stroke="currentColor" stroke-width="1.5"/>
</svg>
